export const iconFontAwesomeShoppingBitcoin = (
	<i className="fa-solid fa-bitcoin"></i>
);
